<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                            </span></h2>
                </v-row>
        
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                       <v-row v-if="!this.formData.lockstaff">
                        <v-col cols="4" sm="4" class="pb-n5">
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupholassigment.selectgrp')"
                                type="text"
                                ref= "groupid"
                                :items="groupList"
                                hide-selected
                                :rules="[rules.required]"
                                @input="updateValue"
                                v-model="formData.groupid"
                                @change ="changeGroupHandler(formData.groupid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                     <v-row v-else>
                        <v-col cols="4" sm="4" class="pb-n5">
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupholassigment.selectgrp')"
                                type="text"
                                ref= "groupid"
                                :items="groupList"
                                hide-selected
                                :rules="[rules.required]"
                                readonly
                                v-model="formData.groupid"
                                dense
                                background-color="#ffeab2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>




                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                           <v-text-field
                                outlined
                                :label="this.$t('setupholassigment.grpvaldesc')"
                                id="groupdesc"
                                type="text"
                                ref="groupdesc" 
                                background-color="#ffeab2"
                                readonly
                                v-model="groupdesc" 
                                dense                       
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.startdate')"
                                type="date"
                                ref="startdate"
                                :rules="[rules.required]"
                                v-model="formData.startdate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.startdate')"
                                type="date"
                                ref="enddate"
                                :rules="[rules.required]"
                                v-model="formData.enddate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                       <v-col cols="4" sm="4" class="pb-n4">
                           <v-autocomplete
                                outlined
                                :label="this.$t('attendancerecordsandprocesses.selectshift')"
                                id = "shiftid"
                                type="text"
                                ref= "shiftid"
                                :items="shiftList"
                                hide-selected
                                :rules="[rules.required]"
                                @input="updateValue"
                                v-model="formData.shiftid"
                                @change ="changeShiftHandler(formData.shiftid)"
                                dense
                        ></v-autocomplete>
                        </v-col>
                   
                       <v-col cols="4" sm="4" class="pb-n4">
                           <v-text-field
                                outlined
                                id="shiftcode"
                                v-model="shiftcode"
                                type="text"
                                :label="this.$t('attendancerecordsandprocesses.shiftcode')"
                                readonly
                                background-color="#ffeab2"
                                dense
                        ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" 
                />

            </v-form>
        </v-container>
    </div>
</template>

<script>
//import GenericForm from '../../generic/GridForm';

export default {
    props: {
        parentObject: Object
    },

    components: {
      //  'app-genericform': GenericForm,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },
            formData: {
                groupid: this.parentObject.data.groupid,
               // wdaygrpdesc: this.parentObject.data.wdaygrpdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
              //  rdaypatterndesc: this.parentObject.data.rdaypatterndesc,
               // rdaypatterncode: this.parentObject.data.rdaypatterncode,
               lockstaff: this.parentObject.data.lockstaff,
                shiftid: this.parentObject.data.shiftid,
                search: this.parentObject.data.search,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },

            groupList: [],
            groupdesc: '',
            valvalue: [],
            shift: [],
            shiftList: [],
            shiftcode: '',

            errMsg: '',
            isErr: false,
             search: this.parentObject.searchnew

        }
    },

    methods: {

        loadValvalueList() {
            const vm = this;

            this.$store.dispatch('get', {
                url: "/groupp_grouppb_workday/all"
            })
                .then(res => {
                    vm.valvalue = res.data.rec;
                    console.log('value', vm.valvalue)

                    for (let i = 0; i < res.data.rec.length; i++) { 
                        {
                            vm.groupList.push(
                                {
                                    text: res.data.rec[i].valuecode,
                                    value: res.data.rec[i].valvalueid
                                }
                            )    
                        }
                    }

                    if (this.formData.groupid) {
                        this.changeGroupHandler(this.formData.groupid);
                    }
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

         changeGroupHandler(valvalueid) {
            let item = this.valvalue.find(item => item.valvalueid === valvalueid);

            this.groupdesc = item.valuedesc;
        },

        loadShiftList() {
            const vm = this;

            this.$store.dispatch('get', {
                url: "/shiftsetup/all"
            })
                .then(res => {
                    vm.shift = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) { 
                        {
                            vm.shiftList.push(
                                {
                                    text: res.data.rec[i].shiftdesc,
                                    value: res.data.rec[i].id
                                }
                            )    
                        }
                    }

                    if (this.formData.shiftid) {
                        this.changeShiftHandler(this.formData.shiftid);
                    }
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

         changeShiftHandler(id) {
            let item = this.shift.find(item => item.id === id);

            this.shiftcode = item.shiftcode;
        },


        updateValue() {
            this.$emit('input', {
                groupid: this.formData.groupid,
              //  wdaygrpdesc: this.formData.wdaygrpdesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                shiftid: this.formData.shiftid,
               // rdaypatterncode: this.formData.rdaypatterncode,
               // rdaypatterndesc: this.formData.rdaypatterndesc,
               lockstaff:this.formData.lockstaff,
               search: this.formData.search,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'workschedulegrouplist', params: { search: this.search}});
        },
    },

    mounted() {
        this.loadValvalueList();
        this.loadShiftList();

         if (this.parentObject.isEdit){
            this.duplicateStaffData = this.formData;
            
            if (this.parentObject.data.lockstaff == "N") {
                this.formData.lockstaff = false;
            } else {
                this.formData.lockstaff = true;
            }
        }
    }
    
}
</script>